<template>
  <div class="supernavbar-workspace-switcher">
    <div class="supernavbar-workspace-switcher-paddings">
      <div
        class="workspace-single-cafe"
        v-for="(entry, index) in uiSwitcherItems.singles"
        :key="index"
        :class="{
          active: cafe._id == entry.entity_id,
        }"
        @click="switchCafe(entry.entity_id)"
      >
        <div class="active-cafe-mark"></div>
        <img
          :src="entry.entity.image || '/icons/navbar-qrwaiter-logo.svg'"
          class="single-cafe-logo"
        />
        <div class="gap-row-3xs">
          <div class="single-cafe-title qrw-label-sm bold">
            {{ entry.title }}
          </div>
          <div
            class="single-cafe-subtitle qrw-label-xs qrw-text-content-base-inverse-secondary"
          >
            {{ entry.subtitle }}
          </div>
        </div>
      </div>
      <div class="divider-container" v-if="uiSwitcherItems.singles.length">
        <BaseDivider color="border-base-inverse-secondary" />
      </div>
      <template v-for="chain in uiSwitcherItems.chains">
        <div class="workspace-chain-block" :key="chain.title">
          <img
            :src="chain.logo || '/icons/navbar-qrwaiter-logo.svg'"
            class="chain-logo"
          />
          <div class="gap-row-zero w-100">
            <div
              class="single-chain-title qrw-label-sm bold qrw-text-content-base-inverse-primary"
            >
              {{ chain.title }}
            </div>
            <div
              class="qrw-label-xs qrw-text-content-base-inverse-secondary w-100"
            >
              {{ $t("add_corporate_cafe.tab_chain") }}
            </div>
          </div>

          <BaseIconButton
            icon="settings-01"
            size="sm"
            variant="ghost"
            textColor="content-base-inverse-secondary"
            hoverColor="background-overlay-a10"
            @click="openChainSettings(chain)"
          />
        </div>

        <div
          class="workspace-chain-item"
          :class="{
            active: cafe._id == chainCafe._id,
          }"
          v-for="chainCafe in chain.cafes"
          :key="chainCafe._id"
          @click="switchCafe(chainCafe._id)"
        >
          <div class="active-chain-mark"></div>
          <BaseIcon icon="marker-pin" size="xs" />
          <div class="qrw-label-sm">{{ chainCafe.name }}</div>
        </div>
      </template>
    </div>

    <div class="add-workspace-block">
      <BasePushButton
        variant="ghost"
        icon="plus"
        size="md"
        class="w-100"
        hoverColor="background-overlay-a10"
        textColor="content-base-inverse-secondary"
        @click="add_cafe_modal = true"
      >
        {{ $t("navbar_pages.workspace_add") }}
      </BasePushButton>
    </div>

    <AddCafeModal
      @close="add_cafe_modal = false"
      @created="onCafeCreated"
      :base_id="null"
      v-if="add_cafe_modal"
    />
  </div>
</template>

<script>
import AddCafeModal from "@/components/corporate/AddCafeModal.vue";

export default {
  data() {
    return {
      add_cafe_modal: false,
    };
  },
  components: {
    AddCafeModal,
  },
  methods: {
    switchCafe(cafe_id) {
      this.$store.commit("selectChain", null);
      this.$store.dispatch("switchCafe", cafe_id).then(() => {
        this.$router.push("/cafe");
        this.$emit("close");
        window.localStorage.setItem(`dashboard_last_cafe`, cafe_id);
      });
    },
    onCafeCreated() {
      this.$store.dispatch("fetchCorporateCafes");
    },
    openChainSettings(chain) {
      this.$router.push({
        name: "chain_settings",
        params: {
          chain_id: chain.id,
        },
      });
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    corporate_cafes() {
      return this.$store.state.corporate_cafes;
    },
    chains() {
      return this.$store.state.chains;
    },
    isNavbarCollapsed() {
      return this.$store.state.ui.navbar_collapsed;
    },
    uiSwitcherItems() {
      let items = [];
      let all_cafes = this.corporate_cafes.slice();

      for (const chain of this.chains) {
        const item = {
          title: chain.name,
          icon: "grid",
          subtitle: this.$t("navbar.chain"),
          type: "chain",
          logo: chain.logo,
          id: chain._id,
          has_subcafes: false,
        };

        items.push(item);

        const chain_cafes = all_cafes.filter(
          (c) => c.chain_id && c.chain_id === chain._id
        );

        if (chain_cafes.length) {
          item.has_subcafes = true;
        }

        item.cafes = chain_cafes;

        all_cafes = all_cafes.filter((c) => c.chain_id !== chain._id);
      }

      items = items.concat(
        all_cafes.map((c) => ({
          title: c.name,
          entity_id: c._id,
          icon: "shop",
          subtitle: c.address
            .split(",")
            .slice(0, 2)
            .join(),
          type: "single_cafe",
          entity: c,
        }))
      );
      return {
        singles: items.filter((i) => i.type === "single_cafe"),
        chains: items.filter((i) => i.type === "chain"),
      };
    },
  },
};
</script>

<style scoped>
.supernavbar-workspace-switcher {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
}

.supernavbar-workspace-switcher-paddings {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 12px;
  box-sizing: border-box;
  height: 100%;
}

.single-cafe-logo {
  border-radius: 4px;
  display: block;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  object-fit: cover;
}

.workspace-single-cafe {
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  padding: 10px 14px;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  box-sizing: border-box;
}

.workspace-single-cafe:hover {
  background: var(--qrw-background-overlay-a10);
}

.workspace-single-cafe.active .active-cafe-mark {
  display: block;
}

.workspace-single-cafe:hover .single-cafe-title {
  color: var(--qrw-content-base-inverse-primary);
}

.single-cafe-title {
  color: var(--qrw-content-base-inverse-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  width: 162px;
}

.single-chain-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  width: 133px;
}

.workspace-single-cafe.active .single-cafe-title {
  color: var(--qrw-content-base-inverse-primary);
}

.single-cafe-subtitle {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  width: 162px;
  color: var(--qrw-content-base-inverse-secondary);
}

.divider-container {
  padding: 10px 8px;
}

.workspace-chain-block {
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  padding: 10px 10px 10px 14px;
  box-sizing: border-box;
  align-items: center;
}

.chain-logo {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: block;
  object-fit: cover;
}

.workspace-chain-item {
  display: flex;
  flex-direction: row;
  column-gap: 6px;
  align-items: center;
  padding: 8px 16px 8px 14px;
  color: var(--qrw-content-base-inverse-secondary);
  cursor: pointer;
  border-radius: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  width: auto;
}

.workspace-chain-item:hover {
  background: var(--qrw-background-overlay-a10);
}

.workspace-chain-item.active {
  color: var(--qrw-content-base-inverse-primary);
}

.workspace-chain-item.active .active-chain-mark {
  display: block;
}

.active-cafe-mark {
  background: var(--qrw-background-base-primary);
  height: 26px;
  width: 2px;
  border-radius: 1px;
  display: block;
  min-width: 2px;
  position: absolute;
  transform: translateX(-8px);
  display: none;
}

.active-chain-mark {
  background: var(--qrw-background-base-primary);
  height: 10px;
  width: 2px;
  border-radius: 1px;
  display: block;
  min-width: 2px;
  position: absolute;
  transform: translateX(-8px);
  display: none;
}

.add-workspace-block {
  padding: 16px;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  align-items: center;
  justify-self: flex-end;
  margin-top: auto;
}
</style>
